var map = {
	"./Group.png": 20066,
	"./apple.png": 49667,
	"./dashboard/circle.png": 93075,
	"./email/fb.png": 26178,
	"./email/medium.png": 29581,
	"./email/slack.png": 83541,
	"./email/twitter.png": 67267,
	"./email/youtube.png": 81065,
	"./facebook.png": 48900,
	"./favicon.png": 24775,
	"./full_logo.png": 3583,
	"./google.png": 2553,
	"./logo.png": 66949,
	"./logo__dashboard.png": 25478,
	"./logo__dashboard2.png": 31328,
	"./logo_large.png": 31806,
	"./logo_large2.png": 62240,
	"./mascota_logo.png": 59684,
	"./mobile-border.png": 23100,
	"./samples/angular-4.png": 58027,
	"./samples/bootstrap-stack.png": 86848,
	"./samples/charts.png": 44271,
	"./samples/dashboard.png": 46887,
	"./samples/e-commerce.png": 32394,
	"./samples/editors.png": 9580,
	"./samples/email.png": 66590,
	"./samples/forms.png": 78640,
	"./samples/html5.png": 21021,
	"./samples/modal.png": 60021,
	"./samples/popup.png": 51159,
	"./samples/widgets.png": 34597,
	"./uruguay.png": 18268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92715;